import { useTranslation } from 'react-i18next';
import { albumData } from '@/mocks/album';
import { useLanguage } from '@/i18n/useLanguage';

export default function TimelineSection() {
  const { t } = useTranslation();
  const lang = useLanguage();

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <p className="text-xs tracking-[0.3em] text-secondary-500 mb-3">TIMELINE</p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">{t('timeline.title')}</h2>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-400 md:-translate-x-px"></div>

          <div className="space-y-10">
            {albumData.timeline.map((item, index) => (
              <div
                key={index}
                className={`relative flex items-start gap-6 md:gap-0 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 -translate-x-1/2 mt-1.5 z-10"></div>

                <div className={`ml-10 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                  <time className="text-xs text-primary-400 font-medium tracking-wider">{item.date}</time>
                  <h3 className="text-sm font-medium text-foreground-900 mt-1">{item[lang].event}</h3>
                  <p className="text-xs text-foreground-600 mt-1.5 leading-relaxed">{item[lang].description}</p>
                </div>

                <div className={`hidden md:block md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12'}`}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}